"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveUri = void 0;
var types_1 = require("../types");
var manifest_1 = require("../manifest");
var apply_redirects_1 = require("./apply-redirects");
var find_plugin_package_1 = require("./find-plugin-package");
var get_implementations_1 = require("./get-implementations");
var interfaces_1 = require("../interfaces");
var tracing_js_1 = require("@web3api/tracing-js");
exports.resolveUri = tracing_js_1.Tracer.traceFunc("core: resolveUri", function (uri, redirects, plugins, interfaces, invoke, createPluginApi, createApi, deserializeOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var finalRedirectedUri, plugin, uriResolverImplementations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                finalRedirectedUri = apply_redirects_1.applyRedirects(uri, redirects);
                plugin = find_plugin_package_1.findPluginPackage(finalRedirectedUri, plugins);
                if (plugin) {
                    return [2 /*return*/, tracing_js_1.Tracer.traceFunc("resolveUri: createPluginApi", function (uri, plugin) { return createPluginApi(uri, plugin); })(finalRedirectedUri, plugin)];
                }
                uriResolverImplementations = get_implementations_1.getImplementations(interfaces_1.coreInterfaceUris.uriResolver, interfaces, redirects);
                return [4 /*yield*/, resolveUriWithUriResolvers(finalRedirectedUri, uriResolverImplementations, invoke, createApi, deserializeOptions)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
var resolveUriWithUriResolvers = function (uri, uriResolverImplementationUris, invoke, createApi, deserializeOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var resolvedUri, uriHistory, trackUriRedirect, tryResolveUriWithUriResolver, i, uriResolver, result, convertedUri, manifest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                resolvedUri = uri;
                uriHistory = [
                    {
                        uri: resolvedUri.uri,
                        source: "ROOT",
                    },
                ];
                trackUriRedirect = function (uri, source) {
                    var dupIdx = uriHistory.findIndex(function (item) { return item.uri === uri; });
                    uriHistory.push({
                        uri: uri,
                        source: source,
                    });
                    if (dupIdx > -1) {
                        throw Error("Infinite loop while resolving URI \"" + uri + "\".\nResolution Stack: " + JSON.stringify(uriHistory, null, 2));
                    }
                };
                tryResolveUriWithUriResolver = function (uri, uriResolver) { return __awaiter(void 0, void 0, void 0, function () {
                    var data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, interfaces_1.UriResolver.Query.tryResolveUri(invoke, uriResolver, uri)];
                            case 1:
                                data = (_a.sent()).data;
                                // If nothing was returned, the URI is not supported
                                if (!data || (!data.uri && !data.manifest)) {
                                    tracing_js_1.Tracer.addEvent("continue", uriResolver.uri);
                                    return [2 /*return*/, undefined];
                                }
                                return [2 /*return*/, data];
                        }
                    });
                }); };
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < uriResolverImplementationUris.length)) return [3 /*break*/, 4];
                uriResolver = uriResolverImplementationUris[i];
                return [4 /*yield*/, tryResolveUriWithUriResolver(resolvedUri, uriResolver)];
            case 2:
                result = _a.sent();
                if (!result) {
                    return [3 /*break*/, 3];
                }
                if (result.uri) {
                    convertedUri = new types_1.Uri(result.uri);
                    trackUriRedirect(convertedUri.uri, uriResolver.uri);
                    tracing_js_1.Tracer.addEvent("uri-resolver-redirect", {
                        from: resolvedUri.uri,
                        to: convertedUri.uri,
                    });
                    // Restart the iteration over again
                    i = -1;
                    resolvedUri = convertedUri;
                    return [3 /*break*/, 3];
                }
                else if (result.manifest) {
                    manifest = manifest_1.deserializeWeb3ApiManifest(result.manifest, deserializeOptions);
                    return [2 /*return*/, tracing_js_1.Tracer.traceFunc("resolveUri: createApi", function (uri, manifest, uriResolver) {
                            return createApi(uri, manifest, uriResolver);
                        })(resolvedUri, manifest, uriResolver)];
                }
                _a.label = 3;
            case 3:
                ++i;
                return [3 /*break*/, 1];
            case 4: 
            // We've failed to resolve the URI
            throw Error("No Web3API found at URI: " + resolvedUri.uri +
                ("\nResolution Path: " + JSON.stringify(uriHistory, null, 2)) +
                ("\nResolvers Used: " + uriResolverImplementationUris));
        }
    });
}); };
//# sourceMappingURL=resolve-uri.js.map